import { render, staticRenderFns } from "./dashboard.vue?vue&type=template&id=4d7ed845&"
import script from "./dashboard.vue?vue&type=script&lang=js&"
export * from "./dashboard.vue?vue&type=script&lang=js&"
import style0 from "./dashboard.vue?vue&type=style&index=0&id=4d7ed845&prod&lang=scss&"
import style1 from "./dashboard.vue?vue&type=style&index=1&id=4d7ed845&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports